import { useWindowDimensions, PixelRatio } from 'react-native';
import { useMemo } from 'react';

export function useIsTablet(): boolean {
  const { width, height } = useWindowDimensions();
  const pixelRatio = PixelRatio.get();

  return useMemo(() => {
    const shortDimension = Math.min(width, height);
    const aspectRatio    = width / height;

    if (shortDimension < 600) return false;

    const isLandscape           = aspectRatio >= 1;
    const isLargeTabletPortrait = shortDimension >= 900; // was wrongly `longDimension >= 900` before
    if (!isLandscape && !isLargeTabletPortrait) return false;

    if (pixelRatio > 2.5) return false;

    return true;
  }, [width, height, pixelRatio]);
}